/** Collection of proof retrieval results. */
export class ProofResults {
  /** All proofs included in the result collection. */
  proofs: ProofResult[];
}

/** Individual proof retrieval results. */
export class ProofResult {
  /** The masked proof value. */
  value: string;
  /** The type of proof. */
  type: string;
}
